import Datepicker from "react-tailwindcss-datepicker";
import getDatepickerLocalisation from "../../utils/localisation";

interface DateSelectorProps {
  label: string;
  showLabel?: boolean;
  dateState: { startDate: any; endDate: any };
  dateHandler: any;
  language: string;
}

export default function DateSelector({
  label,
  showLabel,
  dateState,
  dateHandler,
  language,
}: DateSelectorProps) {
  return (
    <div>
      {/* Label */}
      {showLabel && (
        <label
          className={`mb-3 block text-left text-sm font-medium text-black`}
        >
          {label}
        </label>
      )}

      <div className="grid grid-cols-1 gap-x-2">
        {/* Date picker */}
        <div className="date-picker-wrapper w-full col-span-2">
          <Datepicker
            i18n={getDatepickerLocalisation(language)}
            asSingle={true}
            startFrom={new Date()}
            minDate={new Date()}
            value={dateState}
            onChange={dateHandler}
          />
        </div>
      </div>
    </div>
  );
}
